module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', {}, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "display": "table-cell"
    },
    attrs: {
      "xs12": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-card', {
    staticClass: "mb-0 pb-0"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md7": ""
    }
  }, [_c('v-tabs', {
    staticStyle: {
      "margin-left": "0px",
      "padding-left": "0px"
    },
    attrs: {
      "slider-color": "primary",
      "grow": ""
    },
    model: {
      value: (_vm.activeActivityForm),
      callback: function($$v) {
        _vm.activeActivityForm = $$v
      },
      expression: "activeActivityForm"
    }
  }, [_c('v-tab', {
    key: "tab-1",
    staticClass: "white",
    attrs: {
      "dark": "",
      "href": "#tab-1"
    }
  }, [_c('div', {
    staticStyle: {
      "text-transform": "capitalize",
      "color": "#000",
      "font-size": "19px",
      "font-weight": "900"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    })
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("create")]), _vm._v("Share an update\n                ")], 1)]), _vm._v(" "), _c('v-tab', {
    key: "tab-2",
    attrs: {
      "href": '#tab-2'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.activityPhotoUploaded = true
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-transform": "capitalize",
      "color": "#000",
      "font-size": "19px",
      "font-weight": "900"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    })
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("insert_photo")]), _vm._v("Upload a photo\n                ")], 1)])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "margin-top": "0px",
      "padding": "0px"
    },
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "padding-bottom": "0px",
      "height": "100%"
    },
    attrs: {
      "multi-line": "",
      "full-width": "",
      "auto-grow": "",
      "rows": _vm.dynamicrows,
      "placeholder": "What's on your mind?",
      "id": "addacommText"
    },
    on: {
      "keydown": _vm.submit
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "float": "right",
      "padding-right": "0px"
    },
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "float": "right",
      "font-size": "22px",
      "margin-right": "0px",
      "font-weight": "900"
    },
    attrs: {
      "large": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.postActivity()
      }
    }
  }, [_vm._v("POST")])], 1)], 1), _vm._v(" "), _c('file-upload', {
    attrs: {
      "trigger": _vm.activityPhotoUploaded,
      "formats": ['jpeg', 'png', 'jpg']
    },
    on: {
      "cancel": function($event) {
        _vm.activityPhotoUploaded = false;
        _vm.activityPhotoFile = ''
      },
      "confirm": function($event) {
        return _vm.showActivityPhoto()
      }
    },
    model: {
      value: (_vm.activityPhotoFile),
      callback: function($$v) {
        _vm.activityPhotoFile = $$v
      },
      expression: "activityPhotoFile"
    }
  })], 1), _vm._v(" "), (_vm.activityPhotoFile != '') ? _c('v-card', {
    staticClass: "mt-0 pt-0"
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "id": "close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancelActivityPhoto()
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.activityPhotoFileURL,
      "id": "imgActivity"
    }
  })], 1)]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "load-data-div",
    attrs: {
      "xs12": "",
      "md12": "",
      "id": "alert-div-post"
    }
  }, [_c('v-alert', {
    staticClass: "post-msg",
    attrs: {
      "success": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeAlert()
      }
    }
  }, [_vm._v("\n      Post has been submitted for review\n      "), _c('a', {
    staticClass: "close-btn",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("X")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37a679a3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateActivityComponent.vue
// module id = 1223
// module chunks = 16 17